import React from "react";

const RatingsBadge: React.FC = () => (
  <div className="inline-flex items-center bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
    <span className="text-sm font-medium text-white/90">Trusted by preppers, hunters &amp; reloaders</span>
  </div>
);

export default RatingsBadge;
